import React, { useEffect } from "react";
import { Container, Box, Typography } from "@mui/material";
import PaymentStatusCard from "./components/PaymentStatusCard";
import { useLocation } from "react-router-dom";
import "./payment-status-page.scss";
import { getCartCount } from "../../api/cart.api";
import { useDispatch, useSelector } from "react-redux";

const PaymentStatusPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state: any) => state.session.isLoggedIn);

  const { paymentStatus, details, paymentResult, isOrderSuccess } =
    location.state || {};

  const fetchCartCount = async () => {
    try {
      const response = await getCartCount();
      const count = response.data?.data?.data?.totalCount ?? 0;
      dispatch({ type: "CART:SET_COUNT", payload: { count: count } });
    } catch (error) {
      console.error("ERROR IN FETCHING CART COUNT::", error);
    }
  };

  useEffect(() => {
    if (!isLoggedIn) return;

    // Small delay to ensure backend has updated the cart count after payment
    const timer = setTimeout(() => {
      fetchCartCount();
    }, 1500);
    return () => clearTimeout(timer);
  }, [isLoggedIn]);

  return (
    <Container className="payment-success-page">
      {paymentStatus ? (
        <>
          {/* <Box className="payment-success-page__header">
            <Typography
              variant="subtitle1"
              className="payment-success-page__section-title"
            >
              Payment
            </Typography>
          </Box> */}

          {/* <Typography variant="h4" className="payment-success-page__main-title">
            Payment Successful
          </Typography> */}

          <Box className="payment-success-page__card-container">
            <PaymentStatusCard
              paymentStatus={paymentStatus}
              details={details}
              isOrderSuccess={isOrderSuccess}
            />
          </Box>
        </>
      ) : (
        <>
          {/* <Box className="payment-success-page__header">
            <Typography
            variant="subtitle1"
            className="payment-success-page__section-title"
            >
            Payment
            </Typography>
            </Box> */}

          {/* <Typography variant="h4" className="payment-success-page__main-title">
            Payment Unsuccessful
            </Typography> */}

          <Box className="payment-success-page__card-container">
            <PaymentStatusCard
              paymentStatus={paymentStatus}
              details={details}
              isOrderSuccess={isOrderSuccess}
              paymentIntentId={paymentResult.error?.payment_intent?.id}
            />
          </Box>
        </>
      )}
    </Container>
  );
};

export default PaymentStatusPage;
